import React from "react";
import { withRouter } from "react-router";
import styles from "../Components/CSSFiles/JobsCard.module.css";
import { withTranslation } from "react-i18next";
import { Box, Typography, Button } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import jobUtils from "../../Job/utils/jobUtils.js";

class JobsCard extends React.Component {
  state = {
    jobs: [],
    loading: false,
    error: null,
  };

  componentDidMount() {
    this.fetchJobs();
  }
  
  fetchJobs = async () => {
    const token = localStorage.getItem("token");
    const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}api/v1`;
    const url = `${BASE_URL}/jobs/?limit=4&offset=0`;

    this.setState({ loading: true, error: null });
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Failed to fetch jobs");
      }

      const data = await res.json();

      const jobsArray = Array.isArray(data)
        ? data
        : Array.isArray(data.results)
        ? data.results
        : Array.isArray(data.data)
        ? data.data
        : [];

      // keep next/previous urls if useful later
      const nextUrl = data?.next || null;
      const prevUrl = data?.previous || null;

      this.setState({ jobs: jobsArray, next: nextUrl, previous: prevUrl, loading: false });
    } catch (err) {
      console.error("JobsCard fetch error:", err);
      this.setState({ error: err.message || "Failed to load jobs", loading: false });
    }
  };

  handleView = (job) => {
    if (!job || !job.id) return;
    const encodedTitle = encodeURIComponent(job.title || "");
    this.props.history.push(`/jobs/${job.id}?from=main&related_title=${encodedTitle}`);
  };

  render() {
    const { jobs, loading, error } = this.state;
    const { t } = this.props;

    return (
        <div className={styles.jobsCard}>
          <div className={styles.jobsHeader}>
            <div className={styles.jobsHeaderLeft}>
              <img
                src="/Image/header/jobs.svg"
                alt="jobs"
                className={styles.jobsHeaderIcon}
              />
              <Typography
                sx={{ fontWeight: "600", color: "#535353", fontSize: "15px", marginLeft: 1 }}
              >
                {t("dashboard.jobsCardHeader") || "Your Career Picks"}
              </Typography>
            </div>
          </div>

          {/* Loading / error */}
          {loading && <div className={styles.emptyState}>Loading...</div>}
          {error && <div className={styles.emptyState} style={{ color: "#d32f2f" }}>{error}</div>}

          {/* Jobs list */}
          {!loading && !error && (
            <div className={styles.jobsList}>
              {jobs.length ? (
                jobs.slice(0, 4).map((job, idx) => {
                  const title = job.title || job.role || "Role name";
                  const company = job.company || job.company_name || job.organization || "Company name";

                  return (
                    <div key={idx} className={styles.jobItem}>
                      <div className={styles.jobLeft}>
                        {job?.CompanyData.company_logo ? (
                            <div className={styles.jobAvatar}>
                            <img
                                src={
                                jobUtils.decodeIfProxy(job?.CompanyData?.company_logo) ||
                                jobUtils.decodeIfProxy(job?.CompanyData?.company_logo_link) ||
                                jobUtils.decodeIfProxy(job?.logo) ||
                                "/Image/fallback-company.png"
                                }
                                alt={job?.CompanyData?.company_name || company}
                            />
                            </div>
                        ) : (
                            <div className={styles.jobAvatarText}>
                                {job.CompanyData?.company_name?.charAt(0)?.toUpperCase()}
                            </div>
                        )}

                        <div className={styles.jobInfo}>
                          <p className={styles.jobTitle} title={title} data-full={title}>
                            {title}
                          </p>
                          <p className={styles.jobCompany}>
                            {job.CompanyData?.company_name || company}
                          </p>
                        </div>
                      </div>

                      <button
                        className={styles.viewPill}
                        onClick={() => this.handleView(job)}
                      >
                        {t("common.view") || "View"}
                      </button>
                    </div>
                  );
                })
              ) : (
                <div className={styles.emptyState}>
                  {t("dashboard.noJobs") || "No job picks right now"}
                </div>
              )}
            </div>
          )}

          <div
            className={styles.seeMore}
            onClick={() => this.props.history.push("/jobs")}
            role="button"
            tabIndex={0}
            onKeyPress={() => this.props.history.push("/jobs")}
          >
            <p className={styles.seeMoreText}>
              <span style={{ marginLeft: 5 }}>{t("dashboard.allJobs") || "See more"}</span>
            </p>
          </div>
        </div>
    );
  }
}

export default withTranslation()(withRouter(JobsCard));
